import { lazyPage } from '../../utils/lazyPage';

export const BlogHub = lazyPage(() => import('./BlogHub'));
export const WhatIsFairLine = lazyPage(() => import('./posts/what-is-fairline'));
